import React from "react";
import { HiOutlineCake } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneRestaurant } from "../../../lib/sysNavigation/SysNavigation";

type RestaurantRow = {
  restaurant_id: number | string;
  name?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<RestaurantRow>
    type={_TYPES_.RESTAURANT}
    title="Restaurants"
    subtitle="Restaurants promoted on the public site."
    icon={<HiOutlineCake className="h-5 w-5" />}
    addRoute="/data/restaurant/add"
    editRoute="/data/restaurant/edit"
    pushOne={pushOneRestaurant}
    dataKey="restaurant"
    countKey="restaurantCount"
    idField="restaurant_id"
    titleField="name"
    searchFields={["name"]}
  />
);

export default Overview;
